module.exports = __webpack_public_path__ + "static/Spktral-8225797dcf540247468fa97cb2b2b169.jpg";